"use client";
import { Share2 } from "lucide-react";
import { getInitials } from "./articleHelpers";

export default function ArticleByline({
  author = "Imagive Content Team",
  date,
  onShare,
}) {
  return (
    <div className="flex items-center justify-between gap-4 border-y border-gray-100 py-4 mb-8">
      <div className="flex items-center gap-3">
        <span className="grid place-items-center w-9 h-9 rounded-full bg-[#9573F7]/10 text-xs font-bold text-[#9573F7]">
          {getInitials(author)}
        </span>
        <div>
          <p className="text-sm font-semibold text-gray-900">{author}</p>
          {date && <p className="text-xs text-gray-400">{date}</p>}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onShare}
          className="inline-flex items-center gap-1.5 rounded-full bg-gray-900 px-3.5 py-1.5 text-xs font-medium text-white transition-colors hover:bg-gray-800"
        >
          <Share2 className="w-3.5 h-3.5" /> Share
        </button>
      </div>
    </div>
  );
}
